// Share Sheet (components/share-sheet.php): one click handler for every sheet on the page, and a renderer for
// sheets built client-side (the wishlist modal). Copy Link → "Link Copied" with a check for 2.5s.
var tmShareSheet = {
    render: function (image, title, links, note) {
        var html = '<div class="c-share-sheet"><div class="c-share-sheet__head">'
            + (image ? '<img class="c-share-sheet__image" src="' + tmShareSheet.attr(image) + '" alt="" loading="lazy">' : '')
            + '<div class="c-share-sheet__title">' + tmShareSheet.text(title) + '</div></div><div class="c-share-sheet__links">';
        Object.keys(links || {}).forEach(function (key) {
            var l = links[key];
            // the same classes as share-sheet.php: components/button M ghost block, left-aligned, icon left
            html += '<button type="button" class="c-share-sheet__link c-btn c-btn-medium c-btn-rounded c-btn-ghost c-btn-light-hover c-btn-block c-btn-icon" data-share-type="' + tmShareSheet.attr(key) + '" data-link="' + tmShareSheet.attr(l.url || '') + '">'
                + '<i class="' + tmShareSheet.attr(l.icon || '') + ' fa-fw" aria-hidden="true"></i><span>' + tmShareSheet.text(l.title || '') + '</span></button>';
        });
        html += '</div>' + (note ? '<p class="c-share-sheet__note c-small-text">' + tmShareSheet.text(note) + '</p>' : '') + '</div>';
        return html;
    },
    text: function (s) { return jQuery('<div>').text(String(s)).html(); },
    attr: function (s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); },
    copied: function ($btn) {
        var $label = $btn.find('span'), $icon = $btn.find('i'), label = $label.text(), icon = $icon.attr('class');
        $btn.addClass('c-share-sheet__link--copied');
        $label.text('Link Copied');
        $icon.attr('class', 'fal fa-check fa-fw');
        setTimeout(function () {
            $btn.removeClass('c-share-sheet__link--copied');
            $label.text(label);
            $icon.attr('class', icon);
        }, 2500);
    }
};

jQuery(document).on('click', '.c-share-sheet__link', function (e) {
    e.preventDefault();
    var $btn = jQuery(this), type = $btn.attr('data-share-type'), href = $btn.attr('data-link');
    if (type === 'copyUrl' || type === 'copy') {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(href).then(function () { tmShareSheet.copied($btn); }, function () { window.prompt('Copy this link', href); });
        } else {
            window.prompt('Copy this link', href);
        }
    } else if (type === 'facebook' || type === 'twitter') {
        window.open(href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
    } else if (type === 'mail' || type === 'sms' || type === 'email' || type === 'messages') {
        window.location.href = href;
    } else {
        window.open(href);
    }
});
